import React, { useContext } from 'react';
import LogTableRow from './LogTableRow.jsx';
import { Button } from 'semantic-ui-react';

export default function LogMessageCellContent() {
  const { handleClick, isClicked } = useContext(LogTableRow.Context || {});

  return (
    <Button
      primary
      content={isClicked ? 'Hide Message' : 'Show Message'}
      size='mini'
      onClick={() => handleClick()}
    />
  );
}
